import React from 'react';

const GameWatchModal = ({ game, onClose }) => {
  if (!game) return null;

  return (
    <div
      className="safe-area-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-primary, white)',
          borderRadius: '8px',
          padding: '2rem',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '80dvh',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginBottom: '1rem', color: 'var(--text-primary, #333)' }}>
          Watch Game: {game.name}
        </h2>
        
        {game.description && (
          <p style={{ marginBottom: '1rem', lineHeight: '1.5' }}>
            {game.description}
          </p>
        )}

        <div style={{ marginBottom: '1rem' }}>
          <p style={{ color: 'var(--text-secondary, #666)' }}>
            This feature would allow you to watch gameplay videos or tutorials for this game.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'var(--bg-secondary, #f5f5f5)',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameWatchModal;
